import React from 'react';
import TimelineMilestone from '../cards/TimelineMilestone';
import "../../styles/JourneyTimeline.css"; 

export default function JourneyTimeline() {
  const milestones = [
    { year: "2016", heading: "The Spark", desc: "Started as a tiny artisan workshop with just two master wood and metal carvers.", glowClass: "glow-blue", icon: "✈️" },
    { year: "2019", heading: "Hospitality Pivot", desc: "Began partnering directly with luxury boutique resorts and interior design firms.", glowClass: "glow-orange", icon: "🤝" },
    { year: "2022", heading: "Global Footprint", desc: "Expanded manufacturing operations to export premium lighting to over 50 countries.", glowClass: "glow-blue", icon: "🌐" },
    { year: "2026", heading: "The Future", desc: "Blending traditional Indian craftsmanship with smart-lighting automation ecosystems.", glowClass: "glow-orange", icon: "🚀" }
  ];

  return (
    <section className="about-client-journey-timeline">
      <div className="about-client-max-width">
        
        
        <div className="section-centered-header-node">
          <span className="client-uppercase-overline gold-text">OUR JOURNEY</span>
          <h2 className="client-section-title">From A Spark To A <span className="blue-inline-span">Movement</span></h2>
          
          
          <div className="timeline-header-decoration">
            <div className="header-decor-line"></div>
            <div className="header-decor-center-dot"></div>
            <div className="header-decor-line"></div>
          </div>
        </div>

        
        <div className="timeline-horizontal-axis-container">
          <div className="timeline-connecting-vector-line" />
          
          <div className="timeline-milestones-row-wrapper">
            {milestones.map((milestone, idx) => (
              <React.Fragment key={idx}>
                <TimelineMilestone {...milestone} />
                
                {idx < milestones.length - 1 && (
                  <div className="timeline-track-inter-dot" />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}